import { orchestrator } from 'satcheljs';
import { dismissUserInvitePanel } from '../actions/userInvitationActions';
import { onFormCleared, setUserInvitationErrors, setUserInvitationPanelStatus } from '../mutatorActions';

orchestrator(dismissUserInvitePanel, () => {
  setUserInvitationPanelStatus(false);
  setUserInvitationErrors();
  onFormCleared();
});
